export default {
      id: "telegram-flat-usage",
      viewBox: "0 0 300 300",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#telegram-flat",
      toString: function () {
        return this.url;
      }
    }